import { IconTypes } from './types';
var isMarkInIconTypes = function isMarkInIconTypes(node) {
  return node.marks.some(function (mark) {
    return Object.values(IconTypes).includes(mark.type.name);
  });
};
export var hasMultiplePartsWithFormattingInSelection = function hasMultiplePartsWithFormattingInSelection(_ref) {
  var selectedContent = _ref.selectedContent;
  if (!selectedContent) {
    return false;
  }
  var marks = selectedContent.map(function (child) {
    return isMarkInIconTypes(child) ? child.marks : undefined;
  }).filter(Boolean);
  return marks.length > 1;
};